import React from "react";
import Honda from '../assets/images/Partners/honda.png';
import Diahatsu from '../assets/images/Partners/diahatsu.png';
import BMW from '../assets/images/Partners/electshop.png';
import Mercedes from '../assets/images/Partners/mercedes.png';
import Chevroltet from '../assets/images/Partners/chevrolet.jpg';
import Audi from '../assets/images/Partners/audi.png';
import Alsouq from '../assets/images/Partners/alsouq.png';
import EmirWheels from '../assets/images/Partners/EmirWheels.png';
import MeeForm from '../assets/images/Partners/MeeForm.png';
import lms from '../assets/images/Partners/lms.png';

 const brands = [
    { name: 'Honda', logo: Honda },
    { name: 'Diahatsu', logo: Diahatsu },
    { name: 'BMW', logo: BMW },
    { name: 'Mercedes', logo: Mercedes },
    { name: 'Chevrolet', logo: Chevroltet },
    { name: 'Audi', logo: Audi },
    { name: 'Alsouq', logo: Alsouq },
    { name: 'EmirWheels', logo: EmirWheels },
    { name: 'MeeForm', logo: MeeForm },
    { name: 'LMS', logo: lms },];

const AboutSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 to-blue-50 px-6 md:px-16 lg:px-24 py-24 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute top-0 right-0 w-72 h-72 bg-indigo-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-72 h-72 bg-purple-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000"></div>

      <div className="max-w-7xl mx-auto relative">
        {/* Header Section */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
            <p className="text-blue-600 font-semibold text-lg tracking-wider">
              WHO WE ARE
            </p>
            <div className="w-2 h-2 bg-blue-600 rounded-full ml-3"></div>
          </div>
          
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
            Leading Digital
            <span className="block bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent">
              Transformation Experts
            </span>
          </h2>
          
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-600 mx-auto rounded-full"></div>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left Image Block */}
          <div className="relative group">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Digital transformation team collaboration"
                className="w-full rounded-[40px] shadow-2xl object-cover transform group-hover:scale-[1.02] transition-all duration-700"
              />
              
              {/* Floating Experience Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white p-8 rounded-2xl shadow-2xl border border-gray-100 transform group-hover:scale-105 transition-all duration-500">
                <div className="text-center">
                  <div className="text-blue-600 text-lg font-bold uppercase mb-2">
                    Create
                  </div>
                  <div className="w-12 h-0.5 bg-gradient-to-r from-blue-400 to-indigo-500 mx-auto mb-2"></div>
                  <div className="text-gray-600 text-sm font-medium leading-tight">
                    Innovation • Strategy <br /> Excellence
                  </div>
                </div>
              </div>
            </div>
            
            {/* Background Decorative Element */}
            <div className="absolute -top-6 -right-6 w-full h-full bg-gradient-to-br from-blue-500 to-indigo-600 rounded-[40px] -z-10 transform rotate-3"></div>
          </div>

          {/* Right Content Section */}
          <div className="space-y-8">
            {/* Story Card */}
            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-xl border border-white/60 transform hover:shadow-2xl transition-all duration-500">
              <div className="flex items-center mb-6">
                <div className="w-3 h-8 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full mr-4"></div>
                <h3 className="text-3xl font-bold text-gray-900">Our Story</h3>
              </div>
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                At <span className="font-bold text-blue-600">SafoLife Technologies</span>, 
                we specialize in crafting cutting-edge digital solutions that drive real business growth. 
                Our expertise spans innovative website design and development, powerful mobile applications, 
                strategic digital marketing, and comprehensive CRM automation.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                We tailor our services to meet your unique business needs, delivering measurable results 
                through custom digital transformation strategies that propel your business forward in the 
                digital landscape.
              </p>
            </div>

            {/* Services Highlight */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl p-6 text-white transform hover:-translate-y-2 transition-all duration-300 shadow-lg">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h4 className="font-bold text-lg mb-2">Web Development</h4>
                <p className="text-blue-100 text-sm">Custom websites that drive results and user engagement</p>
              </div>

              <div className="bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl p-6 text-white transform hover:-translate-y-2 transition-all duration-300 shadow-lg">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <h4 className="font-bold text-lg mb-2">Mobile Apps</h4>
                <p className="text-purple-100 text-sm">Native and cross-platform mobile solutions</p>
              </div>
            </div>

            {/* Small Image */}
            <div className="rounded-3xl overflow-hidden shadow-xl transform hover:scale-[1.02] transition-all duration-500">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80"
                alt="Mobile app development team"
                className="w-full h-48 object-cover"
              />
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-12 shadow-2xl border border-white/60 mb-24">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div className="group">
              <div className="relative inline-block">
                <h3 className="text-6xl font-bold text-gray-900 mb-3 transform group-hover:scale-110 transition-transform duration-300">
                  10<span className="text-blue-600">+</span>
                </h3>
                <div className="absolute -inset-4 bg-blue-100 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
              <p className="text-gray-600 font-semibold text-lg">Years Experience</p>
            </div>

            <div className="group">
              <div className="relative inline-block">
                <h3 className="text-6xl font-bold text-gray-900 mb-3 transform group-hover:scale-110 transition-transform duration-300">
                  500<span className="text-blue-600">+</span>
                </h3>
                <div className="absolute -inset-4 bg-indigo-100 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
              <p className="text-gray-600 font-semibold text-lg">Projects Done</p>
            </div>

            <div className="group">
              <div className="relative inline-block">
                <h3 className="text-6xl font-bold text-gray-900 mb-3 transform group-hover:scale-110 transition-transform duration-300">
                  140<span className="text-blue-600">+</span>
                </h3>
                <div className="absolute -inset-4 bg-purple-100 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
              <p className="text-gray-600 font-semibold text-lg">Happy Clients</p>
            </div>

            <div className="group">
              <div className="relative inline-block">
                <h3 className="text-6xl font-bold text-gray-900 mb-3 transform group-hover:scale-110 transition-transform duration-300">
                  98<span className="text-blue-600">%</span>
                </h3>
                <div className="absolute -inset-4 bg-green-100 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
              <p className="text-gray-600 font-semibold text-lg">Client Satisfaction</p>
            </div>
          </div>
        </div>

         <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-8 flex items-center justify-center">
      <div className="max-w-6xl mx-auto w-full">
        <h1 className="text-5xl font-bold text-center mb-16 text-gray-800">
          Our Partners
        </h1>
        
        {/* Animated Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="group relative flex items-center justify-center p-8"
            >
              {/* Floating Animation */}
              <div className="absolute inset-0 bg-white rounded-2xl shadow-lg transform group-hover:scale-110 group-hover:shadow-2xl transition-all duration-500 ease-out opacity-0 group-hover:opacity-100"></div>
              
              {/* Logo with Multiple Animations */}
              <div className="relative transform group-hover:scale-125 group-hover:-translate-y-2 transition-all duration-500 ease-out">
                <img 
                  src={brand.logo} 
                  alt={brand.name}
                  className="w-32 h-32 md:w-40 md:h-40 object-contain filter group-hover:brightness-110 group-hover:contrast-110 transition-all duration-500 ease-out"
                />
                
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-blue-500 rounded-full blur-xl opacity-0 group-hover:opacity-20 transform group-hover:scale-150 transition-all duration-500 ease-out -z-10"></div>
                
                {/* Pulse Animation on Hover */}
                <div className="absolute inset-0 border-2 border-blue-300 rounded-full opacity-0 group-hover:opacity-100 group-hover:scale-150 transition-all duration-500 ease-out -z-10"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Optional: Infinite Scroll Animation Container */}
        <div className="mt-20 overflow-hidden">
          <div className="flex animate-scroll">
            {[...brands, ...brands].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 mx-8 transform hover:scale-125 transition-transform duration-300"
              >
                <img 
                  src={brand.logo} 
                  alt={brand.name}
                  className="w-24 h-24 object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add custom animation for infinite scroll */}
      <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
          display: flex;
          width: max-content;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-3xl p-12 text-white shadow-2xl transform hover:-translate-y-2 transition-all duration-500">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Transform Your Digital Presence?
            </h3>
            <p className="text-blue-100 text-xl mb-8 max-w-2xl mx-auto">
              Let SafoLife Technologies build the perfect web and mobile solutions for your business growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                Start Your Project
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-white hover:text-blue-600 transition-all duration-300">
                View Our Work
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for blob animation */}
      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </section>
  );
};

export default AboutSection;